import * as mobx from 'mobx';
import { IEventDetailsDTO } from '../../api/events.dao';
import { IGlobalStorage } from '../global-storage';
import { IAccountDetailsDTO } from '../../api/accounts.dao';

class GlobalStorage extends IGlobalStorage {
    @mobx.observable
    private event: IEventDetailsDTO;
    @mobx.observable
    private account: IAccountDetailsDTO;


    @mobx.action
    public setEvent(event: IEventDetailsDTO) {
        this.event = event;
    }

    @mobx.action
    public setAccount(account: IAccountDetailsDTO) {
        this.account = account;
    }

    public getEvent(): IEventDetailsDTO | undefined {
        return this.event;
    }

    public getAccount(): IAccountDetailsDTO | undefined {
        return this.account;
    }
}

export { GlobalStorage };